import { render, staticRenderFns } from "./permissionDocument.vue?vue&type=template&id=4c5b9091&scoped=true"
import script from "./permissionDocument.vue?vue&type=script&lang=js"
export * from "./permissionDocument.vue?vue&type=script&lang=js"
import style0 from "./permissionDocument.vue?vue&type=style&index=0&id=4c5b9091&prod&lang=scss"
import style1 from "./permissionDocument.vue?vue&type=style&index=1&id=4c5b9091&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/.pnpm/vue-loader@15.11.1_iiz6arkudjypqgw4ba6ka4cyy4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b9091",
  null
  
)

export default component.exports